import React, { Component } from 'react';
import styles from './detail.module.scss';
import animations from '../../css/animations.scss'
import classnames from 'classnames';
import { CSSTransition } from "react-transition-group"
import { subscribe, unsubscribe } from '../../components/utils/events'
import { notification, Modal } from 'antd'
import history from '../../components/utils/routes/history'

import API from '../../components/utils/API';
import { strings } from '../../components/utils/translations';
import { Utils } from '../../components/utils/utils';
import Alert from '../../components/Alert/alert';
import AddIcon from '../../img/icons/add-icon.svg';
import CloseIcon from '../../img/icons/closeIcon'
import RemotesButton from '../../components/RemotesButton/RemotesButton'

import UserPermissionRemote from '../../components/UserPermissionRemote/userPermissionRemote';
import PermissionMain from '../Permissions/permissionMain';
import VRExpirationTag, { EXPIRATION_DAYS_SHOW_WARNING } from '../../components/VRExpirationTag/VRExpirationTag'

import { Tabs } from 'antd';

export default class DetailRemotes extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
			permissions: [],
			selectedPermission: null,
			myPermission: null,
			isRefreshing: false,
            openUserDetails: false,
            ownersNum: 0,
            guestsNum: 0,
            pendingActivationNum: 0,
			ownersPermissions: null,

			openUserRemoteDetail: false,
			
			totalRemotesIfAdmin: 0,
			remotesInUseIfAdmin: 0
		}
		
		this.userId = API.getInstance().getUserId()

		this.onClickUser.bind(this);
	}
	componentDidMount()
	{
        this.getPermissions();
		
		subscribe('refresh-detail-remotes', () =>
		{
			this.getPermissions()
		})
	}
	componentWillUnmount()
	{
		unsubscribe('refresh-detail-remotes')
	}
	
	componentDidUpdate(prevProps, prevState)
	{
		if (this.props.door !== prevProps.door)
		{
			this.closePermissionCard()
			this.setState({ permissions: [], myPermission: null }, () =>
			{
				this.getPermissions()
			})
		}
	}

	render()
	{
        const { TabPane } = Tabs;
		var totalRemotes = null;
		var availableRemotes = null;
		var inUseRemotes = null;

		if (this.state.myPermission != null)
		{			
			let userIsAdmin = (this.state.myPermission.roleType === 'admin')
			let extraCountWhenNotAdmin = ((!userIsAdmin &&
											this.state.myPermission.virtualRemotes?.assigned != null &&
											!this.state.myPermission.virtualRemotes?.owned.some(vr => vr.virtualRemoteId === this.state.myPermission.virtualRemotes?.assigned.virtualRemoteId)) 
											? 1 : 0)
			
			totalRemotes 		= userIsAdmin ? this.state.totalRemotesIfAdmin : (this.state.myPermission.virtualRemotes?.owned.length + extraCountWhenNotAdmin)
			availableRemotes 	= this.state.myPermission.virtualRemotes?.owned.filter(vr => !vr.virtualRemote?.assigned && !vr.virtualRemote?.reserved).length
			inUseRemotes 		= totalRemotes - availableRemotes
		}

		const remotesCount = <div className={styles.remotesCounterContainer}>
									<div className={styles.remotesCountSingleItem}>
										<h3 className={styles.remotesCountTitle}>{ strings('totalRemotes') }</h3>
										<span className={styles.remotesCountNumber}>{ (totalRemotes != null) ? totalRemotes : '-' }</span>
									</div>
									<div className={styles.remotesCountDoubleItem}>
                                        <div className={styles.remotesContent}>
                                            <h3 className={styles.remotesCountTitle}>{ strings('availableRemotes') }</h3>
                                            <span className={ classnames([styles.remotesCountNumber, styles.available]) }>{ (availableRemotes != null) ? availableRemotes : '-' }</span>
                                        </div>
                                            <span className={styles.separator}></span>
                                        <div className={styles.remotesContent}>
                                            <h3 className={styles.remotesCountTitle}>{ strings('inUseRemotes') }</h3>
                                            <span className={ classnames([styles.remotesCountNumber, styles.inuse]) }>{ (inUseRemotes != null) ? inUseRemotes : '-' }</span>
                                        </div>
									</div>
                                </div>

		return (
			<div className={styles.detailRemotesContainer}>
				{
					(this.state.permissions != null) ?
					<>
						<VRExpirationTag
							door={this.props.door}
							containerStyle={styles.vrExpirationTag}
							bigTag
						/>
						{ remotesCount }
						<div className={ classnames([styles.detailRemotesContent, styles.remotesList]) }>
							<div className="remotesTabs">
								<Tabs defaultActiveKey={ 'admin' }>
									<TabPane tab={ "Admin" } key={ "admin" }>
										{this.state.permissions.map((item) => (
											<>
												{(item.title === "admin") &&
													this.renderPermissionsItem.call(this, item)
												}
											</>
										))}
									</TabPane>
									{
										(this.state.myPermission?.roleType !== 'guest' && !this.state.isRefreshing && this.state.ownersNum > 0) &&
										<TabPane tab={ strings('owners') + ' · ' + `${this.state.ownersNum}` } key={ strings('owners') }>
											{this.state.permissions.map((item) => (
												<>
													{(item.title === strings('owners')) &&
														<>
															{ this.renderPermissionsItem.call(this, item) }
														</>
													}
												</>
											))}
										</TabPane>
									}
									{
										(this.state.guestsNum > 0 && !this.state.isRefreshing) &&
										<TabPane tab={ strings('guests') + ' · ' + `${this.state.guestsNum}` } key={ strings('guests') }>
											{this.state.permissions.map((item) => (
												<>
													{(item.title === strings('guests')) &&
														<>
															{ this.renderPermissionsItem.call(this, item) }
														</>
													}
												</>
											))}
										</TabPane>
									}
									{
										(this.state.myPermission?.roleType !== 'guest' && !this.state.isRefreshing && this.state.pendingActivationNum > 0) &&
										<TabPane tab={ strings('pendingActivationAbbr') + ' · ' + `${this.state.pendingActivationNum}`} key={ strings('pendingActivation') }>
											{this.state.permissions.map((item) => (
												<>
													{(item.title === strings('pendingActivation')) &&
														<>
															{ this.renderPermissionsItem.call(this, item) }
														</>
													}
												</>
											))}
										</TabPane>
									}
								</Tabs>
							</div>

							{
								<CSSTransition
									classNames='permissionDetailAnimation'
									timeout={300}
									in={this.state.openUserDetails}
									mountOnEnter={true}
									unmountOnExit={true}
								>
									<UserPermissionRemote
										door={this.props.door}
										myPermission={this.state.myPermission}
										permission={this.state.selectedPermission}
										roleType={this.props.roleType}
										closeCard={ this.closePermissionCard.bind(this) }
										onDeletePermission={this.onDeletePermission.bind(this)}
									/>
								</CSSTransition>
							}

							{
								(this.props.roleType === 'admin' || this.props.roleType === 'owner') &&
								<RemotesButton
									title={(availableRemotes > 0) ? strings('giveRemote') : strings('obtainRemotes')}
									onClick={() => { (availableRemotes > 0) ? this.props.openPermissions() : this.showOpenBuyRemotesModal()}}
								/>
							}

							{/*
								(this.state.openPermissions) &&
					            <PermissionMain
									door={this.props.door}
									permissions={this.state.permissions}
									closePermissions={() => this.setState({ openPermissions: false })}
					            />
					        */}
						</div>
					</>
					:
					<p className={styles.text}>Error al obtener los mandos del permiso</p>
				}
			</div>
		);
    }
	renderPermissionsItem(cat)
	{
        return (
			cat.data.map((item) => 
			{
				let person = (item.user != null) ? item.user.name + ' ' + item.user.lastName : item.invitationData.guestName;
				if (item.activationDate == null && item.invitationData != null)
					person = item.invitationData.guestName
					
				let {
		            isExpired,
		            daysTilExpiration,
		            isCancelled,
		            isTrial,
					is5years,
					paymentAdded
		        } = Utils.getVRisExpired(item.assignedVirtualRemote)
				
				let hasSubtitle = false
				let subtitleText = null,
					subtitleTextOrange = null
				
				if (isTrial || isCancelled || is5years)
				{
					if (isExpired)
					{
						hasSubtitle = true
						subtitleTextOrange = strings('expired')
					}
					else if (daysTilExpiration <= EXPIRATION_DAYS_SHOW_WARNING)
					{
						hasSubtitle = true
						subtitleTextOrange = strings('expiresSoon')
						
						if (isTrial && paymentAdded)
						{
							hasSubtitle = false
							subtitleTextOrange = null
						}
					}
				}
				
				var remoteIconView = null;
				let subscriptionType = item.assignedVirtualRemote?.subscription?.type
				let remoteIcon = require('../../img/icons/remote_gray.svg').default
				if (subscriptionType === '1 year')
					remoteIcon =  require('../../img/icons/remote_purple.svg').default
				else if (subscriptionType === '5 years')
					remoteIcon =  require('../../img/icons/remote_gold.svg').default
					
				var numRemotes = (item.virtualRemotes?.assigned != null) ? 1 : 0
				
				if (item.roleType != 'external-service' &&
					(this.state.myPermission.roleType == 'admin' ||
					(this.state.myPermission.roleType == 'owner' && item.roleType != 'admin')))
				{
					if (item.activationDate == null)
						numRemotes = 1 + item.permissionsToGrant
					else if (this.state.myPermission.roleType == 'admin' && item.roleType == 'owner')
						numRemotes += item.virtualRemotes?.owned.filter(vr => !vr.virtualRemote?.assigned && !vr.virtualRemote?.reserved).length
						
					remoteIconView = <div className={styles.remoteIconPermissions}>
										<span className={styles.permissionNumber}>{ numRemotes }</span>
										<img height="20" width="14" src={remoteIcon} />
									</div>
				}
				
				return (
					<div key={`${item.id}`} className={styles.remotesListContainer} onClick={() => { this.onClickUser(item) }}>
						<div className={classnames(styles.actionCircle, {[styles.purple]: item.user != null && item.user.id == this.userId && item.activationDate != null })}>
						{
							(item.activationDate == null && item.invitationData != null) ?
							<span className={styles.name}>{ Utils.getInitials(item.invitationData.guestName) }</span>
							:
							<span className={styles.name}>{ Utils.getInitials((item.user != null) ? item.user.name + ' ' + item.user.lastName : item.invitationData.guestName) }</span>
						}
						</div>
						<div className={styles.remoteListPermissions}>
							{
								<div>
									<p className={styles.text}>{person}</p>
									{
										hasSubtitle &&
										<span className={styles.label}>
											{ subtitleText }
											{ subtitleTextOrange && <span className={styles.orange}>{ subtitleTextOrange }</span> }
										</span>
									}
								</div>
							}
							{ remoteIconView }
						</div>
					</div>
				)
			})
		)
	}

	getPermissions()
	{
		this.setState({ isRefreshing: true });

		API.getInstance().getPermissions(this.props.door.id)
		.then(response =>
		{
			this.setState({ isRefreshing: false }, () =>
			{console.log(response.data.permissions)
				if (response.data != null && response.data.permissions != null)
				{
					this.separatePermissions(response.data.permissions);
				}
				else
				{
                    notification.error(
		            {
		                description: strings('getPermissionsError'),
		                placement: 'topRight'
		            })
				}
			});
		})
		.catch(error =>
		{
			console.log(error);

			this.setState({ isRefreshing: false });
            
			notification.error(
			{
				description: strings('getPermissionsError'),
				placement: 'topRight'
			})
		});
	}
	separatePermissions(allPermissions)
	{
		var admin = { data: [], title: "admin" }
		var owners = { data: [], title: strings('owners') }
		var guests = { data: [], title: strings('guests') }
		var services = { data: [], title: strings('newGenerationServices') }
		var pending = { data: [], title: strings('pendingActivation') }
		var permissions = []
		var newState = { totalRemotesIfAdmin: 0 }

		allPermissions.sort((a, b) =>
		{
			if (a.roleType == 'admin')
				return -1;
			else if (b.roleType == 'admin')
				return 1;
			else
			{
				var nameA = (a.user != null) ? a.user.name + ' ' + a.user.lastName : a.invitationData.guestName;
				var nameB = (b.user != null) ? b.user.name + ' ' + b.user.lastName : b.invitationData.guestName;

				nameA = Utils.removeAccents(nameA.toUpperCase());
				nameB = Utils.removeAccents(nameB.toUpperCase());

				if (nameA < nameB)
					return -1;
				if (nameA > nameB)
					return 1;

				return 0;
			}
        });

		allPermissions.map(permission =>
		{
			if (permission.activationDate == null)
			{
				pending.data.push(permission);
			}
			else
			{
				if (permission.roleType == 'external-service')
					services.data.push(permission);
				else if (permission.roleType == 'admin')
					admin.data.push(permission);
				else if (permission.roleType == 'guest')
					guests.data.push(permission);
				else
					owners.data.push(permission);
					
				if (permission.virtualRemotes)
					newState.totalRemotesIfAdmin += permission.virtualRemotes?.owned.length
            }

			if (this.userId == permission.userId && permission.activationDate != null)
				newState.myPermission = permission;
		});
		
		if (admin.data.length > 0)
            permissions.push(admin);

		if (owners.data.length > 0)
            permissions.push(owners);

		if (guests.data.length > 0)
			permissions.push(guests);

		if (services.data.length > 0)
			permissions.push(services);

		if (pending.data.length > 0)
			permissions.push(pending);

		newState.permissions = permissions
		newState.ownersNum = 0
		newState.guestsNum = 0
		newState.pendingActivationNum = 0
		
		if (this.props.onSeparatePermissions != null)
			this.props.onSeparatePermissions(permissions);
        this.setState(newState, () =>
		{
			permissions.map(item => {
				if (item.data != null && item.title == strings('owners'))
					this.setState({
						ownersNum: item.data.length
					})
				else if (item.data != null && item.title == strings('guests'))
					this.setState({
						guestsNum: item.data.length
					})
				else if (item.data != null && item.title == strings('pendingActivation'))
					this.setState({
						pendingActivationNum: item.data.length
					})
			})
		})
	}

	onClickUser(permission)
	{
		if (permission.roleType === 'admin' &&
			this.state.myPermission.roleType != 'admin')
			return
		
		this.setState({
			selectedPermission: permission,
			openUserDetails: !this.state.openUserDetails,
			openUserRemoteDetail: true
		}, () =>
		{
			this.props.openUserRemoteDetail(this.state.openUserRemoteDetail)
		})
	}

	closePermissionCard(refreshPermissions)
	{
		this.setState({ openUserDetails: false, openUserRemoteDetail: false }, () =>
		{
			this.props.openUserRemoteDetail(this.state.openUserRemoteDetail)
			
			if (refreshPermissions)
				this.getPermissions()
		});
	}
	
	showOpenBuyRemotesModal()
	{
		Modal.confirm(
		{
			title: strings('obtainRemotes'),
			content: <div>{strings('obtainRemotsText')}</div>,
			okText: strings('obtainRemotes'),
			cancelText: strings('cancel'),
			onOk: () => this.openBuyRemotesScreen(),
			centered: true,
			autoFocusButton: null,
			closable: true,
			icon: null
		})
	}
	openBuyRemotesScreen()
    {
        history.push("/extra-virtual-remotes?house_id="+this.props.door.houseId)
    }
	
	onDeletePermission()
	{
		if (this.props.onDeletePermission)
			this.props.onDeletePermission()
	}
}
